import { createApiRef } from '@backstage/core-plugin-api';

import { FrameworkId } from '@internal/backstage-plugin-framework-versions-common';

import { Release } from '../lib/status';

export interface EolApi {
  getReleases(id: FrameworkId): Promise<Release[]>;
}

export const eolApiRef = createApiRef<EolApi>({
  id: 'plugin.framework-versions.eol',
});
